export const templateForList = [
  'invoice',
  'otp',
  'order_accepted',
  'order_dispatch',
  'delivery_otp',
  'order_delivered',
  'order_rejected',
  'assigned_del_boy',
  'garment_ready_to_delivery',
  'garment_booking',
];
